import CloseIcon from '@mui/icons-material/Close';
import { Box, Chip, Typography } from '@mui/material';

import type { EpiChatSendPayload } from '../types/epi-chat-types';

interface QueuedMessagesStripProps {
  queue: EpiChatSendPayload[];
  onDequeue: (index: number) => void;
}

export const QueuedMessagesStrip = ({ queue, onDequeue }: QueuedMessagesStripProps) => {
  if (queue.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        padding: 1,
        backgroundColor: (theme) => theme.palette.action.hover,
        borderRadius: 1,
        marginBottom: 1,
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
        Queued while the agent finishes:
      </Typography>
      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
        {queue.map((item, index) => (
          <Chip
            key={index}
            size="small"
            label={item.text.length > 60 ? `${item.text.slice(0, 60)}…` : item.text}
            deleteIcon={<CloseIcon fontSize="small" />}
            onDelete={() => onDequeue(index)}
          />
        ))}
      </Box>
    </Box>
  );
};
